import { useEffect, useRef } from 'react';

import { useGameMenuItems } from 'js/app/components/main/Games/components/ControlPanel/hooks/useGameMenuItems';
import { useFilterDynamicCategory } from 'js/app/components/main/Games/hooks/useFilterDynamicCategory';
import { selectActiveCategory } from 'js/app/components/main/Games/store/actions';
import { useGamesDispatch } from 'js/app/components/main/Games/store/context';

export const useSetDefaultCategory = ({ isLoading, category }) => {
    const isOnce = useRef(false);
    const dispatch = useGamesDispatch();
    const gameMenuItems = useGameMenuItems();
    const filterCategory = useFilterDynamicCategory();

    useEffect(() => {
        if (isLoading || isOnce.current) {
            return;
        }

        if (!filterCategory(category)) {
            dispatch(selectActiveCategory(gameMenuItems[0]?.name));
            isOnce.current = true;
        }
    }, [category, dispatch, filterCategory, gameMenuItems, isLoading]);
};
